<template>
  <div id="qsteam" :style="bg">
    <div>
      <div class="qcontent" v-for="(rginfos, i) in question.steam" :key="i">
        <span v-for="(item, j) in rginfos.wordInfos" :key="j">
          <span v-if="item.wdType === 1" name="imglatex"
            >${{ item.latex }}$</span
          >
          <img v-else-if="item.wdType === 2" :src="item.buffer" />
          <span class="tex2jax_ignore" v-else>{{ item.content }}</span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "questionstem",
  data: () => ({
    charcodes: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    normalCanvas: "background: white",
    oddCanvas: "background:rgb(170, 170, 170)",

    radio: "",
    multx: [],
    str: "\u3000",
    correct: false,
    orderList: [
      {
        value: 0,
        label: "A"
      },
      {
        value: 1,
        label: "B"
      },
      {
        value: 2,
        label: "C"
      },
      {
        value: 3,
        label: "D"
      },
      {
        value: 4,
        label: "E"
      },
      {
        value: 5,
        label: "F"
      },
      {
        value: 6,
        label: "G"
      },
      {
        value: 7,
        label: "H"
      },
      {
        value: 8,
        label: "I"
      }
    ]
  }),
  props: {
    showmode: Number,
    question: {
      type: Object,
      default: function() {
        return {
          steam: [],
          slove: [],
          options: [],
          fill: [],
          hasops: false,
          hasfill: false,
          hasslove: false,
          level: 1
        };
      }
    },
    tableid: {
      type: Number,
      default: -1
    },
    knowledged: {
      type: String
    },
    qID: {
      type: String
    },
    index: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    // 移除自动洗牌逻辑，避免副作用导致选项顺序不一致
    // this.randomSortArray(this.question.options);
  },
  methods: {
    randomSortArray(arr) {
      var len = arr.length;
      for (var i = len - 1; i >= 0; i--) {
        var randomIndex = Math.floor(Math.random() * (i + 1));
        var temp = arr[randomIndex];
        arr[randomIndex] = arr[i];
        arr[i] = temp;
      }
      return arr;
    },
    opendialogVisible() {
      this.question.hasslove = true;
      this.correct = true;
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {});
    }
  },

  computed: {
    bg() {
      return {
        // backgroundImage: "url(" + require("@/assets/watermark.png") + ")",
        backgroundRepeat: "repeat",
        backgroundSize: "128px 64px"
      };
    }
  }
};
</script>

<style scoped>
.qtitle {
  display: flex;
  align-items: left;
  margin-bottom: 6px;
  line-height: 24px;
}

.qtitle .qknowledge {
  margin-right: 15px;
}
.qtitle .qqID {
  margin-right: 15px;
}
.qtitle .tbID {
  margin-right: 15px;
}
.qcontent {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  align-content: flex-start;
  background: transparent;
}
.qoption {
  display: flex;
  background: transparent;
  align-items: center;
  flex-wrap: wrap;
  align-content: flex-start;
}
.tex2jax_ignore {
  font-size: 24px;
  font-family: "宋体";
}
.qcontent .qtext {
  font-size: 24px;
  font-family: "宋体";
}
.qoption .qtext {
  font-size: 24px;
  font-family: "宋体";
}
</style>
